import React from "react";
import styled from "styled-components";

const StyledBody = styled.div`
  flex: 1;
`;

interface ModalBodyProps {
  children: React.ReactNode;
}

export const ModalBody: React.FC<ModalBodyProps> = ({ children }) => (
  <StyledBody>{children}</StyledBody>
);
